import { ExperimentList, TreatmentExperimentMap, ExperimentIdentifier } from '~shared/types/pricing/experiments';

export const EXPERIMENT_IDENTIFIERS: ExperimentIdentifier = {
  ENTERPRISE_FEATURES_GP69: {
    name: 'gp_69_pnp_sme_features',
    treatment: 'gp_69_pnp_sme_treatment',
  },
  GROW_2529_FORMS: {
    name: 'grow_2529_forms_pricing_page',
    treatment1: 'grow_2529_forms_pricing_page_treatment1',
    treatment2: 'grow_2529_forms_pricing_page_treatment2',
  },
  GROW_2629_FORMS_V2: {
    name: 'grow_2629_forms_pricing_page_marketing',
    treatment: 'grow_2629_forms_pricing_page_marketing_treatment',
  },
  GROW_2427: {
    name: 'grow_2427_pnp_social_proof',
    treatment: 'grow_2427_pnp_social_proof_treatment',
  },
  GROW_2763: {
    name: 'grow_2763_gb_ca_and_edu_price_test',
    treatment: 'grow_2763_gb_ca_and_edu_price_test_treatment',
  },
  GROW_2792: {
    name: 'grow_2792_pnp_refresh_v1',
    treatment: 'grow_2792_pnp_refresh_v1_treatment',
  },
  IG_2825: {
    name: 'ig_2825_expand_basic_v3',
    treatment1: 'ig_2825_expand_basic_v3_treatment_b',
    treatment2: 'ig_2825_expand_basic_v3_treatment_c',
    treatment3: 'ig_2825_expand_basic_v3_treatment_d',
  },
};

// A map of `price_test` treatment names to the original experiment
// identifier. Only experiments that have been added to experimentsvc
// as a "managed experiment" should be added here.
// ALL TREATMENTS INCLUDING CONTROL MUST BE ADDED
//
// This step is needed since we get price tests with the magical experiment
// identifier "price_test", which hands us a treatment but not the original
// experiment identifier.
//
// Price tests are generally used to test package price changes, but some times
// also make changes to displayed features or some other UI change. If this is
// the case for your test, be sure to add it to `FEATURE_EXPERIMENTS` or
// `UI_EXPERIMENTS` below so other experiments will not be considered
export const PRICE_TEST_TREATMENTS: TreatmentExperimentMap = {
  grow_2629_forms_pricing_page_marketing_control: EXPERIMENT_IDENTIFIERS.GROW_2629_FORMS_V2.name,
  grow_2629_forms_pricing_page_marketing_treatment: EXPERIMENT_IDENTIFIERS.GROW_2629_FORMS_V2.name,
  grow_2529_forms_pricing_page_control: EXPERIMENT_IDENTIFIERS.GROW_2529_FORMS.name,
  grow_2529_forms_pricing_page_treatment1: EXPERIMENT_IDENTIFIERS.GROW_2529_FORMS.name,
  grow_2529_forms_pricing_page_treatment2: EXPERIMENT_IDENTIFIERS.GROW_2529_FORMS.name,
  grow_2763_gb_ca_and_edu_price_test_control: EXPERIMENT_IDENTIFIERS.GROW_2763.name,
  grow_2763_gb_ca_and_edu_price_test_treatment: EXPERIMENT_IDENTIFIERS.GROW_2763.name,
};

// same situation as above, but for "feature_test"
export const FEATURE_TEST_TREATMENTS: TreatmentExperimentMap = {
  ig_2825_expand_basic_v3_control: EXPERIMENT_IDENTIFIERS.IG_2825.name,
  ig_2825_expand_basic_v3_treatment_b: EXPERIMENT_IDENTIFIERS.IG_2825.name,
  ig_2825_expand_basic_v3_treatment_c: EXPERIMENT_IDENTIFIERS.IG_2825.name,
  ig_2825_expand_basic_v3_treatment_d: EXPERIMENT_IDENTIFIERS.IG_2825.name,
};

// A list of experiments that may change the display of prices. If your experiment
// is listed in PRICE_TEST_TREATMENTS above, you do not need to add it again! If
// a user is not assigned to any running price_test, we will start checking
// for assignments against this list of experiment identifiers
export const PRICE_EXPERIMENTS: ExperimentList = [
  EXPERIMENT_IDENTIFIERS.GROW_2792.name,
  EXPERIMENT_IDENTIFIERS.GROW_2629_FORMS_V2.name, // order matters for these forms experiment
  EXPERIMENT_IDENTIFIERS.GROW_2529_FORMS.name,
];

// A list of experiments that may change the display of features. This can include
// an experiment being run as a price_test, but if your experiment is already in
// FEATURE_TEST_TREATMENTS, DO NOT ADD IT HERE
export const FEATURE_EXPERIMENTS: ExperimentList = [];

// A list of experiments that will alter the UI of the page and are significant
// enough that they should not overlay with each other. If you have a price test or
// feature test above that makes changes to the UI, you should add them here so the
// user isn't added to a different UI experiment
export const UI_EXPERIMENTS: ExperimentList = [
  EXPERIMENT_IDENTIFIERS.ENTERPRISE_FEATURES_GP69.name,
  EXPERIMENT_IDENTIFIERS.GROW_2427.name,
  EXPERIMENT_IDENTIFIERS.GROW_2629_FORMS_V2.name, // order matters for these forms experiment
  EXPERIMENT_IDENTIFIERS.GROW_2529_FORMS.name,
];
